import { View } from "react-native";

import Button from "$src/core/components/atoms/Button/Button";
import Text from "$src/core/components/atoms/Text/Text";
import useTranslation from "$src/core/hooks/use-translation";
import Logging from "$src/core/services/logging/logging";

import $ from "./SubscriptionOfferCard.styles";
import type { SubscriptionOfferCardProps } from "./types";

const getPeriodTranslationKey = (period: "month" | "year") => {
  switch (period) {
    case "month":
      return "COMMON/PERIOD/MONTH";
    case "year":
      return "COMMON/PERIOD/YEAR";
    default:
      Logging.error(`Invalid period: ${period as string}`);
      return "COMMON/PERIOD/MONTH";
  }
};

const SubscriptionOfferCard = ({
  offer,
  isActive = false,
  isUpgrade = false,
  isDowngrade = false,
  onRequestActivation,
  onRequestUpgrade,
  onRequestDowngrade,
  onRequestCancellation,
}: SubscriptionOfferCardProps) => {
  const { t, c } = useTranslation();

  return (
    <View style={$.offerCard({ isActive })}>
      <Text preset="heading2" accessibilityRole="header">
        {offer.title}
      </Text>
      <Text preset="tiny" accessibilityRole="text" style={$.offerDescription}>
        {offer.description}
      </Text>
      <View style={$.offerPrice}>
        <Text preset="heading3" accessibilityRole="text">
          {[
            c(offer.price.amount, offer.price.currency),
            "/",
            t(getPeriodTranslationKey(offer.period)),
          ].join(" ")}
        </Text>
        {isActive && onRequestCancellation ? (
          <Button
            name="subscription_offers_cancel"
            preset="transparent"
            label={t("PROFILE/SUBSCRIPTION_OFFERS/CANCEL")}
            onPress={onRequestCancellation}
          />
        ) : isUpgrade && onRequestUpgrade ? (
          <Button
            name="subscription_offers_upgrade"
            preset="primary"
            label={t("SUBSCRIPTION_OFFERS/ACTIVATION/UPGRADE")}
            onPress={onRequestUpgrade}
          />
        ) : isDowngrade && onRequestDowngrade ? (
          <Button
            name="subscription_offers_downgrade"
            preset="primary"
            label={t("SUBSCRIPTION_OFFERS/ACTIVATION/DOWNGRADE")}
            onPress={onRequestDowngrade}
          />
        ) : onRequestActivation ? (
          <Button
            name="subscription_offers_subscribe"
            preset="primary"
            label={t("SUBSCRIPTION_OFFERS/ACTIVATION/SUBSCRIBE")}
            onPress={onRequestActivation}
          />
        ) : null}
      </View>
    </View>
  );
};

export default SubscriptionOfferCard;
